import { useTranslation } from 'react-i18next';
import { cn, PaletteUtils, RoutePaths } from '@shared/utils';
import { Button, Icon, Text } from '@shared/widgets';
import TravelIcon from '@assets/icons/travel.svg';
import CheckIcon from '@assets/icons/check.svg';

interface PromoProps {
  className?: string;
}

export const Promo = (props: PromoProps) => {
  const { t } = useTranslation('travel');

  const features = [t('promo.features.team'), t('promo.features.bookings'), t('promo.features.available')];
  return (
    <section
      className={cn(
        'flex flex-col items-center justify-center gap-6 bg-white p-20 dark:bg-soft-black',
        'max-lg:p-10',
        'max-md:min-h-0 max-md:p-6',
        PaletteUtils.isVcfcPalette && 'rounded-xl dark:border dark:border-gray-black',
        props.className,
      )}
    >
      <Icon
        className={cn('flex size-16 items-center justify-center rounded-2xl bg-ghost-white', 'dark:bg-light/10')}
        icon={<TravelIcon className='size-6' />}
      />
      <div className='flex flex-col gap-3'>
        <Text tag='h2' center size='2xl' weight='semibold'>
          {t('promo.title')}
        </Text>
        <Text className='w-full max-w-[570px]' tag='p' center>
          {t('promo.description')}
        </Text>
      </div>
      <ul className={cn('flex flex-wrap items-center justify-center gap-x-6 gap-y-3', 'max-md:flex-col max-md:items-start')}>
        {features.map((feature) => (
          <li key={feature} className='flex items-center gap-2'>
            <Icon className='shrink-0' icon={<CheckIcon />} color='green' />
            <Text>{feature}</Text>
          </li>
        ))}
      </ul>
      <Button className='px-8' color='primary' to={RoutePaths.travelEnrol.onNavigate()}>
        {t('promo.button')}
      </Button>
    </section>
  );
};
